import { Label } from "@/components/ui/label";

const base =
  "w-full rounded-lg border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-800/40 focus:border-emerald-800 transition";

export const Field = ({ label, name, required, type = "text", value, onChange, placeholder, testId, ...rest }) => (
  <div className="space-y-1.5">
    {label && (
      <Label className="text-sm font-medium text-slate-700">
        {label} {required && <span className="text-brass-600">*</span>}
      </Label>
    )}
    <input
      className={base}
      name={name}
      type={type}
      required={required}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
      {...rest}
    />
  </div>
);

export const Area = ({ label, name, value, onChange, placeholder, testId, rows = 4, required }) => (
  <div className="space-y-1.5">
    {label && <Label className="text-sm font-medium text-slate-700">{label} {required && <span className="text-brass-600">*</span>}</Label>}
    <textarea
      className={base}
      name={name}
      rows={rows}
      required={required}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      data-testid={testId}
    />
  </div>
);

export const Selectable = ({ label, name, value, onChange, options, testId, required, placeholder = "Please select" }) => (
  <div className="space-y-1.5">
    {label && <Label className="text-sm font-medium text-slate-700">{label} {required && <span className="text-brass-600">*</span>}</Label>}
    <select className={base} name={name} value={value} required={required} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
      <option value="">{placeholder}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  </div>
);
